enum Environment {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
  RAINFORESTQA = 'rainforestqa',
  SANDBOX = 'sandbox',
  STAGING = 'staging',
}

export default Environment;
